import React, { Fragment, Suspense, useEffect, useState } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import Loader from "../Layout/Loader";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoute from "./PrivateRoute";
import Signin from "../Auth/Login";
import { useDispatch, useSelector } from "react-redux";
import { fetchNavbar } from "../Auth/api";
import MenuComp from "../Layout/SideBar-Layout/Menu";
import RoutesComp from "./Routes";
import { navbarSelector } from "../Auth/navbarSlice";
import { io } from "socket.io-client";
import { config } from "../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FreshWorksWidget from "../FreshWorksWidget";
import socketManager from "../utils/socket";

const Routers = () => {
  const [socket, setSocket] = useState(null);

  const Msg = ({ text }) => <div className="d-flex">{text}</div>;

  const notifyToastObj = {
    position: "top-right",
    autoClose: 150000,
    hideProgressBar: false,
    progressClassName: "bg-white",
    progressStyle: { background: "#FFFFFF" },
    style: {
      background: "#FFF",
      fontSize: "16px",
      fontFamily: "Azo Sans",
    },
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    className: "bg-black text-white",
  };

  function notify(data) {
    console.log('datadata:', data)
    if (data.hotelId === localStorage.getItem("hotelId")) {
      toast(<Msg text={data.message} />, notifyToastObj);
      console.log("Notification data -- ", data);
      new Notification(data.title, {
        body: data?.message,
        // requireInteraction : true,
        tag: data.messageId,
        // renotify:true
      });
    }
  }

  function notify1Minute(data) {
    console.log('datadata:', data)
    if (data.hotelId === localStorage.getItem("hotelId")) {
      toast(<Msg text={data.message} />, notifyToastObj);
      console.log("Notification data -- ", data);
      new Notification(data.title, {
        body: data?.message,
        // requireInteraction : true,
        tag: data.messageId,
        // renotify:true
      });
    }
  }

  const notyfyActivityRequest = (data) => {
    if (data.hotelId === localStorage.getItem("hotelId")) {
      toast(<Msg text={data.message} />, notifyToastObj);
      new Notification(data.title, {
        body: data?.message,
      });
    }
  };

  const notyfyReedemOfferRequest = (data) => {
    console.log({ socketData: data });

    if (data.hotelId === localStorage.getItem("hotelId")) {
      toast(<Msg text={data.message} />, notifyToastObj);
      new Notification(data.title, {
        body: data?.message,
      });
    }
  };

  const test_notification = (data) => {
    console.log({ socketData: data });

    if (data.hotelId === localStorage.getItem("hotelId")) {
      toast(<Msg text={data.message} />, notifyToastObj);
      new Notification(data.title, {
        body: data?.message,
      });
    }
  };

  useEffect(() => {
    const socket = socketManager.getSocket();
    socketManager.connect(); // Ensures it's connected (once)
    if (socket) {
      socket.on("connect", (data) => {
        // socket.emit("joined", { serverchannel: 120 });
        console.log("Connected", data);
      });

      socketManager.on("service_request_notify", notify);

      socketManager.on("service_request_new_notify", notify1Minute);

      socketManager.on("activity_request_notify", notyfyActivityRequest);

      socketManager.on("reedem_offer_notify", notyfyReedemOfferRequest);

      socketManager.on("test_notification", test_notification);

      console.log(socketManager.id);
    }

    return () => {
      console.log("offing socket...");
      socket.off("service_request_notify", notify);
      console.log("offed socket...");
    };
  }, []);

  const jwt_token = localStorage.getItem("token");
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isLoading, profileData } = useSelector(navbarSelector);
  useEffect(() => {
    if (jwt_token) {
      dispatch(fetchNavbar());
    }
  }, []);

  if (jwt_token && isLoading) {
    return <Loader />;
  }

  let hotelCode = localStorage.getItem("hotelcode");
  console.log("Routes/index.js >> hotelCode:", hotelCode);

  return (
    <Fragment>
      {/* <MenuComp /> */}
      {/* <RoutesComp /> */}
      
      <Suspense fallback={<Loader />}>
        <FreshWorksWidget />
        <Routes>
          <Route path={"/"} element={<PrivateRoute />}>
            {jwt_token && (
              <>
                <Route path={"/"} element={<Navigate to={`services`} />} />
              </>
            )}
            <Route path={"/*"} element={<LayoutRoutes />} />
          </Route>
          <Route
            path={"/login"}
            element={!hotelCode ? <Navigate to={`/`} /> : <Signin />}
          />
        </Routes>
      </Suspense>
    </Fragment>
  );
};

export default Routers;
